export default "__VITE_ASSET__a70cf404__"